import { Box, SpaceBetween } from "@amzn/awsui-components-console";
import React from "react";

const MetadataConfigurationHelpPanel: React.FC = () => (
  <SpaceBetween size="m">
    <Box>
      <h3>Metadata Configuration</h3>
      <p>
        Control which Iconik metadata fields the AI agent can use and which are
        shown to users in the clip preview panel.
      </p>
    </Box>
    <Box>
      <h3>What the columns do</h3>
      <ul>
        <li>
          <strong>Available to agent</strong> — when on, the agent may filter
          and reason over this field when answering questions.
        </li>
        <li>
          <strong>Show in preview</strong> — when on, the field appears as a
          read-only row in the clip preview side panel.
        </li>
        <li>
          <strong>Values</strong> — for dropdown fields, the allowed options.
          Use <strong>+N more</strong> to see the full list.
        </li>
        <li>
          <strong>Last changed by</strong> — who last changed a field's flags,
          and when.
        </li>
      </ul>
    </Box>
    <Box>
      <h3>Notes</h3>
      <ul>
        <li>Changes take effect on the next asset load.</li>
        <li>Use the search box to find a field by name or display label.</li>
      </ul>
    </Box>
  </SpaceBetween>
);

export default MetadataConfigurationHelpPanel;
